export const SET_TASKS_LIST = "SET_TASKS_LIST";

export const CREATE_TASK = "CREATE_TASK";

export const DELETE_TASK = "DELETE_TASK";

export const EDIT_TASK = "EDIT_TASK";
